import moment from 'moment';

export const formatDateTime = (
  value: Date | string | number | null | undefined,
  format = 'DD/MM/YYYY HH:mm:ss',
): string => {
  if (!value) return '';
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format(format) : '-';
};

export const formatNumber = (value: number | string | null | undefined, decimals = 0, locale = 'en-US'): string => {
  if (value === null || value === undefined || value === '') return '-';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return '-';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
};

export const normalizeText = (text: string) => {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
};

export const isEmpty = (value: any): boolean => {
  return (
    value === null ||
    value === undefined ||
    (typeof value === 'string' && value.trim() === '') ||
    (Array.isArray(value) && value.length === 0)
  );
};

export const formatIOSString = (value: any) => (value instanceof Date ? value.toISOString() : value);
